function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import cf from 'currency-formatter';
/*
Why don't we use Intl.NumberFormat?
- It doesn't have wide enough currency support, e.g. no symbols for PLN and SEK, even in chrome.

Why are we customising this lib?
- AWX's standard differs from the library's standard.  AWX's standard is used in the backend too - mainly number of decimal places.
- The library formats currencies according to the corresponding locale's number formatting rules, whereas we do not (`1,234.56` vs `1 234,56`).  Think that's a lib bug; Intl.NumberFormat keeps the concepts separate too.

Why are there two standards?  Shouldn't AWX and this lib just follow the global standard?
- The reason for the difference in standards is that the official standard / reality isn't very consistent.  e.g.
  - IDR's number of decimal places differs by context (banking vs consumer)
  - CHF's symbol differs by language
  - HKD has multiple symbols ($ or HK$).
*/

var currencyFormatOverrides = {
  BHD: {
    // official standard is 3; but our vendor only supports 2
    decimalDigits: 2
  },
  CHF: {
    symbol: 'Fr'
  },
  EUR: {
    symbolOnLeft: true
  },
  HKD: {
    symbol: '$'
  },
  IDR: {
    decimalDigits: 2
  },
  USD: {
    symbol: '$'
  },
  ILS: {
    symbol: '₪'
  }
}; // replace currency-formatter default settings with AWX standard

cf.currencies.forEach(function (currency, index) {
  Object.assign(cf.currencies[index], _objectSpread(_objectSpread({}, currencyFormatOverrides[currency.code]), {}, {
    spaceBetweenAmountAndSymbol: false
  }));
});
export function formatCurrency(_ref) {
  var amount = _ref.amount,
      currency = _ref.currency,
      _ref$showCode = _ref.showCode,
      showCode = _ref$showCode === void 0 ? true : _ref$showCode,
      _ref$showSymbol = _ref.showSymbol,
      showSymbol = _ref$showSymbol === void 0 ? false : _ref$showSymbol;
  var symbolAndAmount = cf.format(amount, _objectSpread({
    code: currency,
    thousand: ',',
    decimal: '.'
  }, !showSymbol && {
    symbol: ''
  }));
  return "".concat(symbolAndAmount).concat(showCode ? " ".concat(currency) : '');
}